
<p-toast></p-toast>
<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>Costing & Contract Information</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="action-btn">
                                    <button pButton pRiple icon="pi pi-search" title="Back to Search"
                                        class="p-button p-button-success p-mr-2" ></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <!-- <p-tabView  [(activeIndex)]="selectedtab">
                            <p-tabPanel header="Customer Details"> -->
                        <table class="normal-table">
                            <tr>

                                <td style="width:17%" class="text-right">
                                    Temp Customer <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <input type="text" disabled pInputText>
                                        <button class="p-inputgroup-addon p-button" title="Add" type="button"
                                            (click)="showBasicDialog()">
                                            <i class="las la-search"></i>
                                        </button>
                                    </div>

                                </td>
                                <td class="text-right">Temp Customer Site <span class="hlt-txt">*</span></td>
                                <td>
                                    <input type="text" disabled pInputText>
                                </td>
                                <!-- <td class="text-right">Company Type <span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [filter]="true" optionLabel="name"></p-dropdown>
                                </td> -->
                                <td class="text-right">Billing Branch <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <p-dropdown [filter]="true" optionLabel="name"></p-dropdown>
                                </td>
                            </tr>
                            <tr>
                                <!-- <td class="text-right">Customer Type <span class="hlt-txt">*</span></td>
                                        <td>
                                            <p-dropdown [filter]="true" optionLabel="name"></p-dropdown>
                                        </td> -->
                                <td class="text-right">Minimum Freight Charges <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">Minimum Chargeable Weight <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">Minimum VSC Charges <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                            </tr>
                          
                            <tr>


                                <td class="text-right">Rate Per Quintal RATE / KM <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <!-- <td class="text-right">Minimum AC Charges <span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [filter]="true" optionLabel="name"></p-dropdown>
                                </td> -->
                                <td class="text-right">Fuel Price Per Ltr <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Quoted Qtl Per KM<span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>

                            </tr>
                            <tr>                                                              
                                <td class="text-right">Expected Sales <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Temp Customer Commmunication Mail<span class="hlt-txt">*</span></td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <div class="browse-links">
                                                <!-- <p-button label="Link" styleClass="p-button-link"></p-button> -->
                                            </div>
                                        </span>
                                        <p-fileUpload class="p-inputgroup-addon p-button p-button-icon-only"
                                            pTooltip="Browse File" tooltipPosition="top" mode="basic" name="demo[]"
                                            accept="image/*" maxFileSize="1000000" chooseLabel="" #fileUpload>
                                        </p-fileUpload>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Cancel"
                                            tooltipPosition="top">
                                            <i class="las la-times"></i>
                                        </button>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                           
                        </table>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Credit evaluation limit to be fix & credit days</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            <tr>
                                <td class="text-right">Credit Limit  <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Invoice Credit Days  <span class="hlt-txt">*</span></td>
                                <td>
                                    <input type="text" pInputText>
                                </td>
                                <td></td>
                                <td></td>
                               
                            </tr>
                        </table>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>DC Charges</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            <tr>
                                <td class="text-right">Minimum DC Charges <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Cost to company <span class="hlt-txt">*</span></td>
                                <td>
                                    <input type="text" pInputText>
                                </td>
                                <td class="text-right">Cost to Agent <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                            </tr>
                        </table>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>DD Charges</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            <tr>
                                <td class="text-right">Minimum DD Charges <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Cost to company <span class="hlt-txt">*</span></td>
                                <td>
                                   <input type="text" pInputText>
                                </td>
                                <td class="text-right">Cost to Agent <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                            </tr>
                        </table>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>AC Charges</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            <tr>
                                <td class="text-right">Minimum AC Charges <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Cost to company <span class="hlt-txt">*</span></td>
                                <td>
                                   <input type="text" pInputText>
                                </td>
                                <td class="text-right">Cost to Agent <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                            </tr>
                        </table>
                        <!-- <p-tabView [(activeIndex)]="selectedtab">
                            <p-tabPanel header="General Rate"> -->

                                <div class="sub-title">
                                    <div class="row">
                                        <div class="col-md-5">
                                            <h5>Contract</h5>
                                        </div>
                                        <div class="col-md-7"></div>
                                    </div>
                                </div>
                            <table class="normal-table">
                                <tr>
                                    <td class="text-right">
                                        Contract Type<span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <!--p-dropdown [autoDisplayFirst]="false" placeholder="Select"  [filter]="true" [(ngModel)]="typeid"  (onChange)="ChangeContractType($event)"
                                        [options]="_ContractType" optionValue="contacttypeid" optionLabel="contacttypename">
                                    </p-dropdown-->
                                    <p-multiSelect  [options]="_ContractType" placeholder="Select"  [filter]="true" [(ngModel)]="typeid" optionValue="contacttypeid" optionLabel="contacttypename" (onChange)="ChangeContractType($event)"></p-multiSelect>
                                    </td>
                                    <td></td> 
                                    <td></td> 
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                               

                                <div class="sub-title" [hidden]="HideGeneralRate">
                                    <div class="row">
                                        <div class="col-md-5">
                                            <h5>General </h5>
                                        </div>
                                        <div class="col-md-7"></div>
                                    </div>
                                </div>
                                <table class="normal-table" [hidden]="HideGeneralRate">
                                    <tr>
                                        <td class="text-right">Rate Per Quintal/KM <span class="hlt-txt">*</span></td>
                                        <td><input type="text" pInputText></td>
                                        <td class="text-right">ODA Calculation Mode	 <span class="hlt-txt">*</span></td>
                                        <td>
                                            <div class="p-field-radiobutton">
                                                <p-radioButton name="yes" value="yes"  inputId="1"
                                                    label="Basic Freight"></p-radioButton>
        
                                                <p-radioButton name="no" value="no"  inputId="2"
                                                    label="Door Delivery"></p-radioButton>
                                            </div>
                                        </td>
                                        <td class="text-right">Special Rate <span class="hlt-txt">*</span></td>
                                        <td><input type="text" pInputText></td>
                                    </tr>
                                </table>
                                <!-- <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>
        
                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
        
                                 
                                        <p-table #dt [value]="GeneralRateList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                        [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                         [showCurrentPageReport]="true">
                                      
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th pSortableColumn="agentNo">General Rate  <p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Rate Per Quintal/KM  <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                               
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_agentListGrid>
                                            <tr>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div> -->
                            <!-- </p-tabPanel> -->
                            <!-- <p-tabPanel header="Article Based"> -->
                                <div class="sub-title" [hidden]="HideArticleBased">
                                    <div class="row">
                                        <div class="col-md-5">
                                            <h5>Article Based</h5>
                                        </div>
                                        <div class="col-md-7"></div>
                                    </div>
                                </div>
                                <table class="normal-table" [hidden]="HideArticleBased">
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <!-- <td style="width:17%" class="text-right">
                                            TAT Based on <span class="hlt-txt">*</span>
                                        </td> -->
                                        <td >
                                            <input name="file-upload-field" type="file" class="file-upload-field"  placeholder="Upload file" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"> 
                                        </td>
                                       
                                        <td colspan="2">
                                            <button pButton label="Validate Uploaded Data" class="p-button-success"></button>
                                            <button pButton label="Download Template" class="p-button-success"></button>
                                        </td>
                                        <td></td>
                                        <!-- <td></td> -->
                                    </tr>
                                </table>
                                <div class="card" [hidden]="HideArticleBased">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>
        
                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
        
                                    <!-- <p-table #dt [value]="GeneralRateList" [scrollable]="true" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                        [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                        <p-table #dt [value]="GeneralRateList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"                                         
                                         [showCurrentPageReport]="true" [scrollable]="true">
                                         <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">                                                
                                                <col style="width:150px">
                                            </colgroup>
                                        </ng-template> 
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th style="text-align: center;width: 100px;" rowspan="2">Action</th>
                                                <th pSortableColumn="agentNo">Sno <p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">From Branch<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentNo">To Branch<p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Article Name  <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentNo">Rate Type ( KG / Art) <p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Rate <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DC Rate Type <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DC Rate<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DD Rate Type<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DD Rate<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Article Charge Code<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">AC Rate<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Add on Charges<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Reverse Booking<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                               
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_agentListGrid>
                                            <tr>
                                                <td style="text-align: center">
                                                    <button pButton pRipple title="Add" icon="pi pi-plus"
                                                        class="p-button-success p-mr-2"></button>
                                                    <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                        class="p-button-danger p-mr-2"></button>
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                
                                                
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            <!-- </p-tabPanel> -->
                            <!-- <p-tabPanel header="Region Level"> -->
                                <div class="sub-title" [hidden]="HideRegionLevel">
                                    <div class="row">
                                        <div class="col-md-5">
                                            <h5>Region Level</h5>
                                        </div>
                                        <div class="col-md-7"></div>
                                    </div>
                                </div>
                                <table class="normal-table" [hidden]="HideRegionLevel">
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <!-- <td style="width:17%" class="text-right">
                                            TAT Based on <span class="hlt-txt">*</span>
                                        </td> -->
                                        <td >
                                            <input name="file-upload-field" type="file" class="file-upload-field"  placeholder="Upload file" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"> 
                                        </td>
                                       
                                        <td colspan="2">
                                            <button pButton label="Validate Uploaded Data" class="p-button-success"></button>
                                            <button pButton label="Download Template" class="p-button-success"></button>
                                        </td>
                                        <td></td>
                                        <!-- <td></td> -->
                                    </tr>
                                </table>
                                <div class="card" [hidden]="HideRegionLevel">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>
        
                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
        
                                    <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                        [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                        <p-table #dt [value]="GeneralRateList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                        [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                         [showCurrentPageReport]="true" [scrollable]="true">
                                         <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                            </colgroup>
                                        </ng-template> 
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th style="text-align: center;width: 100px;" rowspan="2">Action</th>
                                                <th pSortableColumn="agentNo">Sno <p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">From Branch<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentNo">To Region<p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Article<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentNo">Rate Type<p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DC Rate Type<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DC Rate<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DD Rate Type<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DD Rate<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Article Charge Code<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">AC Rate<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Add on Charges<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Reverse Booking<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                               
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_agentListGrid>
                                            <tr>
                                                <td style="text-align: center">
                                                    <button pButton pRipple title="Add" icon="pi pi-plus"
                                                        class="p-button-success p-mr-2"></button>
                                                    <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                        class="p-button-danger p-mr-2"></button>
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                
                                                
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            <!-- </p-tabPanel> -->
                            <!-- <p-tabPanel header="Slab"> -->
                                <div class="sub-title" [hidden]="HideSlab">
                                    <div class="row">
                                        <div class="col-md-5">
                                            <h5>Slab</h5>
                                        </div>
                                        <div class="col-md-7"></div>
                                    </div>
                                </div>
                                <table class="normal-table" [hidden]="HideSlab">
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <!-- <td style="width:17%" class="text-right">
                                            TAT Based on <span class="hlt-txt">*</span>
                                        </td> -->
                                        <td >
                                            <input name="file-upload-field" type="file" class="file-upload-field"  placeholder="Upload file" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"> 
                                        </td>
                                       
                                        <td colspan="2">
                                            <button pButton label="Validate Uploaded Data" class="p-button-success"></button>
                                            <button pButton label="Download Template" class="p-button-success"></button>
                                        </td>
                                        <td></td>
                                        <!-- <td></td> -->
                                    </tr>
                                </table>
                                <div class="card" [hidden]="HideSlab">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>
        
                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
        
                                    <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                        [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                        <p-table #dt [value]="GeneralRateList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                        [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                         [showCurrentPageReport]="true" [scrollable]="true">
                                         <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                            </colgroup>
                                        </ng-template> 
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th style="text-align: center;width: 100px;" rowspan="2">Action</th>
                                                <th pSortableColumn="agentNo" >Sno <p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName"> From Branch<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentNo">To Branch<p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Article<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentNo">Rate Type<p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DC Rate Type <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DC Rate <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DD Rate Type <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DD Rate <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Article Charge Code <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">AC Rate <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Add on Charges <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Reverse Booking <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                               
                                               
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_agentListGrid>
                                            <tr>
                                                <td style="text-align: center">
                                                    <button pButton pRipple title="Add" icon="pi pi-plus"
                                                        class="p-button-success p-mr-2"></button>
                                                    <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                        class="p-button-danger p-mr-2"></button>
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            <!-- </p-tabPanel> -->
                            <!-- <p-tabPanel header="2D Rate "> -->
                                <div class="sub-title" [hidden]="Hide2DRate">
                                    <div class="row">
                                        <div class="col-md-5">
                                            <h5>2D Rate</h5>
                                        </div>
                                        <div class="col-md-7"></div>
                                    </div>
                                </div>
                                <table class="normal-table" [hidden]="Hide2DRate">
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <!-- <td style="width:17%" class="text-right">
                                            TAT Based on <span class="hlt-txt">*</span>
                                        </td> -->
                                        <td >
                                            <input name="file-upload-field" type="file" class="file-upload-field"  placeholder="Upload file" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"> 
                                        </td>
                                       
                                        <td colspan="2">
                                            <button pButton label="Validate Uploaded Data" class="p-button-success"></button>
                                            <button pButton label="Download Template" class="p-button-success"></button>
                                        </td>
                                        <td></td>
                                        <!-- <td></td> -->
                                    </tr>
                                </table>
                                <div class="card" [hidden]="Hide2DRate">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>
        
                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
        
                                    <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                        [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                        <p-table #dt [value]="GeneralRateList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                        [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                         [showCurrentPageReport]="true" [scrollable]="true">
                                         <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                            </colgroup>
                                        </ng-template> 
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th style="text-align: center;width: 100px;" rowspan="2">Action</th>
                                                <th pSortableColumn="agentNo">Sno <p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">From Branch<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentNo">To KM  <p-sortIcon field="agentNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Article<p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                              
                                                <th pSortableColumn="agentName">Rate Type <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Slab <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DC Rate Type <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DC Rate <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DD Rate Type <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">DD Rate <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Article Charge Code	 <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">AC Rate <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="agentName">Add on Charges <p-sortIcon field="agentName">
                                                    </p-sortIcon>
                                                </th>
                                             
                                               
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_agentListGrid>
                                            <tr>
                                                <td style="text-align: center">
                                                    <button pButton pRipple title="Add" icon="pi pi-plus"
                                                        class="p-button-success p-mr-2"></button>
                                                    <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                        class="p-button-danger p-mr-2"></button>
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentNo}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                               
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                <td>
                                                    {{_agentListGrid.agentName}}
                                                </td>
                                                
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            <!-- </p-tabPanel> -->
                           
                            <!-- </p-tabPanel>
                        </p-tabView> -->
                        
                        <div class="sub-title" [hidden]="HideArticleODA">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Article - ODA Charges</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table" [hidden]="HideArticleODA">
                            <tr>
                                <td class="text-right">Article From<span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" [options]="_FlatOdaList" optionLabel="name" 
                                    optionValue="id" [(ngModel)]="id"  (onChange)="ChangeFlatODAMapping($event)"
                                    >
                                </p-dropdown>
                                </td>
                                <td class="text-right">Article To <span class="hlt-txt">*</span></td>
                                <td>
                                    <input type="text" pInputText>
                                </td>
                                <td class="text-right">Article Charges<span class="hlt-txt">*</span></td>
                                <td>
                                    <input type="text" pInputText>
                                </td>
                               
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Add" class="p-button-success" ></button>
                                    <button pButton label="Clear" class="p-button-warning" ></button>
                                </td>
                            </tr>
                        </table>
                        <div class="card" [hidden]="HideArticleODA">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                <p-table #dt [value]="GeneralRateList" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                 [showCurrentPageReport]="true" [scrollable]="true">
                                 <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <!--<col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">-->
                                    </colgroup>
                                </ng-template> 
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="text-align: center;width: 100px;" rowspan="2">Action</th>
                                        <th pSortableColumn="agentNo">Sno <p-sortIcon field="agentNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">Article From<p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentNo">Article To <p-sortIcon field="agentNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">Article Charges<p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                      
                                        <th pSortableColumn="agentName">Effective From <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">Effective To <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                       
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_agentListGrid>
                                    <tr>
                                        <td style="text-align: center">
                                            <!-- <button pButton pRipple title="Add" icon="pi pi-plus"
                                                class="p-button-success p-mr-2"></button> -->
                                            <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                class="p-button-danger p-mr-2"></button>
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentName}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentName}}
                                        </td>
                                       
                                        <td>
                                            {{_agentListGrid.agentName}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentName}}
                                        </td>
                                        
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div class="sub-title" [hidden]="HideTonnageODA">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>KG - ODA Charges</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table" [hidden]="HideTonnageODA">
                            <tr>
                                <td class="text-right">KG From<span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" [options]="_FlatOdaList" optionLabel="name" 
                                    optionValue="id" [(ngModel)]="id"  (onChange)="ChangeFlatODAMapping($event)"
                                    >
                                </p-dropdown>
                                </td>
                                <td class="text-right">KG To <span class="hlt-txt">*</span></td>
                                <td>
                                    <input type="text" pInputText>
                                </td>
                                <td class="text-right">KG Charges<span class="hlt-txt">*</span></td>
                                <td>
                                    <input type="text" pInputText>
                                </td>
                               
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Add" class="p-button-success" ></button>
                                    <button pButton label="Clear" class="p-button-warning" ></button>
                                </td>
                            </tr>
                        </table>
                        <div class="card" [hidden]="HideTonnageODA">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                <p-table #dt [value]="GeneralRateList" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                 [showCurrentPageReport]="true" [scrollable]="true">
                                <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                       <!--  <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">-->
                                    </colgroup>
                                </ng-template> 
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="text-align: center;width: 100px;" rowspan="2">Action</th>
                                        <th pSortableColumn="agentNo">Sno <p-sortIcon field="agentNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">KG From<p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentNo">KG To <p-sortIcon field="agentNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">KG Charges<p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                      
                                        <th pSortableColumn="agentName">Effective From <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">Effective To <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                       
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_agentListGrid>
                                    <tr>
                                        <td style="text-align: center">
                                            <!-- <button pButton pRipple title="Add" icon="pi pi-plus"
                                                class="p-button-success p-mr-2"></button> -->
                                            <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                class="p-button-danger p-mr-2"></button>
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentName}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentName}}
                                        </td>
                                       
                                        <td>
                                            {{_agentListGrid.agentName}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentName}}
                                        </td>
                                        
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Waybill Heads / Other Charges</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <!-- <p-tabPanel header="Waybill Heads / Other Charges"> -->
                            <div class="card">
                                <p-toolbar styleClass="p-mb-4">
                                    <ng-template pTemplate="left">
                                        <span class="p-input-icon-left">
                                            <i class="las la-search"></i>
                                            <input pInputText type="text"
                                                (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                placeholder="Search..." />
                                        </span>
                                    </ng-template>
    
                                    <ng-template pTemplate="right">
                                        <button type="button" pButton pRipple icon="las la-file-excel"
                                            title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                            tooltipPosition="bottom"></button>
                                    </ng-template>
                                </p-toolbar>
    
                                <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                    [rowsPerPageOptions]="[10,25,50,100]"
                                    [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                    [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                    <p-table #dt [value]="GeneralRateList" [rows]="10" [paginator]="true"
                                    [rowsPerPageOptions]="[10,25,50,100]"
                                    [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                    [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                     [showCurrentPageReport]="true" [scrollable]="true">
                                     <ng-template pTemplate="colgroup" let-columns>
                                        <colgroup>
                                            <col style="width:150px">
                                            <col style="width:150px">
                                            <col style="width:150px">
                                            <col style="width:150px">
                                            <col style="width:150px">
                                            <col style="width:150px">
                                            <col style="width:150px">
                                            <!--col style="width:150px">
                                            <col style="width:250px">
                                            <col style="width:250px">
                                            <col style="width:250px">
                                            <col style="width:250px">
                                            <col style="width:250px">
                                            <col style="width:250px"-->
                                        </colgroup>
                                    </ng-template> 
                                    <ng-template pTemplate="header">
                                        <tr>
                                           
                                            <th style="text-align: center;width: 100px;" rowspan="2">Action</th>
                                            <th pSortableColumn="agentNo">Sno <p-sortIcon field="agentNo"></p-sortIcon>
                                            </th>
                                            <th pSortableColumn="agentName">Charges type<p-sortIcon field="agentName">
                                                </p-sortIcon>
                                            </th>
                                            <th pSortableColumn="agentNo">Charge Rate Type ( Choose) <p-sortIcon field="agentNo"></p-sortIcon>
                                            </th>
                                            <th pSortableColumn="agentName">Rate  <p-sortIcon field="agentName">
                                                </p-sortIcon>
                                            </th>
                                          
                                            <th pSortableColumn="agentName">Inclusive / exclusive <p-sortIcon field="agentName">
                                                </p-sortIcon>
                                            </th>
                                            <th pSortableColumn="agentName">Remark <p-sortIcon field="agentName">
                                                </p-sortIcon>
                                            </th>
                                           
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-_agentListGrid>
                                        <tr>
                                            <td style="text-align: center">
                                                <button pButton pRipple title="Add" icon="pi pi-plus"
                                                    class="p-button-success p-mr-2"></button>
                                                <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                    class="p-button-danger p-mr-2"></button>
                                            </td>
                                            <td>
                                                {{_agentListGrid.agentNo}}
                                            </td>
                                            <td>
                                                {{_agentListGrid.agentName}}
                                            </td>
                                            <td>
                                                {{_agentListGrid.agentNo}}
                                            </td>
                                            <td>
                                                {{_agentListGrid.agentName}}
                                            </td>
                                           
                                            <td>
                                                {{_agentListGrid.agentName}}
                                            </td>
                                            <td>
                                                {{_agentListGrid.agentName}}
                                            </td>
                                            
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                            <div class="sub-title">
                                <div class="row">
                                    <div class="col-md-5">
                                        <h5>ODA Mapping</h5>
                                    </div>
                                    <div class="col-md-7"></div>
                                </div>
                            </div>
                            <table class="normal-table">
                                <tr>
                                    <td style="width:17%" class="text-right">
                                        ODA Charges Agree <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" pInputText>
                                    </td>
                                    <td class="text-right">Cost Type<span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" pInputText>
                                    </td>
                                   <td></td>
                                   <td></td>
                                </tr>
                                <tr>
                                    <td style="width:17%" class="text-right">
                                        Cost to Company in % <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" pInputText>
                                    </td>
                                    <td class="text-right">Cost to Agent  in %<span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" pInputText>
                                    </td>
                                    <td class="text-right">ODA Mapping <span class="hlt-txt">*</span></td>
                                    <td>
                                        <!-- <p-dropdown [autoDisplayFirst]="false" [options]="_OdaList" optionLabel="name" 
                                        optionValue="id" [(ngModel)]="id"  (onChange)="ChangeODAMapping($event)"
                                        >
                                    </p-dropdown> -->
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select"  [filter]="true" [(ngModel)]="id"  (onChange)="ChangeODAMapping($event)"
                                    [options]="_OdaList" optionValue="id" optionLabel="name">
                                </p-dropdown>
                                    </td>
                                </tr>
                                <tr [hidden]="HideOpenTYpe">
                                    
                                    <td class="text-right">State<span class="hlt-txt">*</span></td>
                                    <td>
                                        <p-multiSelect  [options]="_State" placeholder="Select" optionValue="stateid"  optionLabel="statename"></p-multiSelect>
                                    </td>
                                    <td class="text-right">Minimum ODA Charges<span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" pInputText>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr [hidden]="HideFlatTYpe">
                                    
                                    <td class="text-right">Flat ODA Charges Based On<span class="hlt-txt">*</span></td>
                                    <td>
                                        <p-dropdown [autoDisplayFirst]="false" [options]="_FlatOdaList" optionLabel="name" 
                                        optionValue="id" [(ngModel)]="idflat"  (onChange)="ChangeFlatODAMapping($event)"
                                        >
                                    </p-dropdown>
                                    </td>
                                    <td class="text-right">Minimum ODA Charges <span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" pInputText>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr [hidden]="HideServiceable">
                                    
                                   
                                    <td class="text-right">Minimum ODA Charges <span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" pInputText>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr [hidden]="HideTranscationTYpe">
                                    
                                    <td class="text-right">ODA Charges<span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" pInputText>
                                    </td>
                                    <td class="text-right">Minimum ODA Charges <span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" pInputText>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Comments</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            <tr>
                                <!-- <td class="text-right" rowspan="2"> <span class="hlt-txt">*</span></td>
                                <td rowspan="2"><textarea inputId="textarea" rows="2" cols="30"
                                        pInputTextarea></textarea></td> -->
                                        <td style="width:17%" class="text-right">Comments <span class="hlt-txt">*</span></td>
                                        <td colspan="5"><textarea inputId="textarea" rows="2" cols="30" pInputTextarea></textarea></td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Save" class="p-button-success" icon="las la-check"></button>
                                    <button pButton label="Clear" class="p-button-warning" icon="las la-broom"></button>
                                </td>
                            </tr>
                        </table>
                        <p-dialog header="Customer" [(visible)]="displayBasic" [modal]="true"
                            [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                            <ng-template pTemplate="content">
                                <div class="popup-body">
                                    <div class="search-container">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label">
                                                <input type="text" id="inputtext" pInputText>
                                            </span>
                                            <button class="p-inputgroup-addon p-button" title="Search">
                                                <i class="pi pi-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <p-table [value]="_Expenses" selectionMode="single"
                                            [(selection)]="selectedRequest" (onRowSelect)="onRowSelectPopup($event)"
                                            (onRowUnselect)="onRowUnSelectPopup($event)" [paginator]="true" [rows]="10">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <!-- <th *ngIf="_action != 'view'">
                                                </th> -->
                                                    <th pSortableColumn="requestno">Customer Name <p-sortIcon
                                                            field="requestno">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Customer Tally ID
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestperson">Customer Type <p-sortIcon
                                                            field="requestperson">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Is Transporter
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Billing Cycle
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>


                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-rowData let-_Expense>
                                                <tr>
                                                    <!-- <td style="text-align: center" *ngIf="_action != 'view'">
                                                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                                </td> -->
                                                    <td>{{_Expense.pettycashsettlementid}}</td>
                                                    <td>{{_Expense.settlementamount}}</td>
                                                    <td>{{_Expense.balanceamount}}</td>
                                                    <td>{{_Expense.settlementamount}}</td>
                                                    <td>{{_Expense.balanceamount}}</td>

                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </div>
                            </ng-template>
                        </p-dialog>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
